import { useGLTF } from '@react-three/drei';
import React from 'react';
import { base } from '../../constants';

export const Floor = () => {
    const object = useGLTF(base+ '/content/environment/Floor.glb');
    return <primitive object={object.scene} />;
};
